import { render, staticRenderFns } from "./GangJobs.vue?vue&type=template&id=0ef51ab3&scoped=true&"
import script from "./GangJobs.vue?vue&type=script&lang=js&"
export * from "./GangJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef51ab3",
  null
  
)

export default component.exports